<template>
<div class="advanced">
  <div class="backup">
    <div class="backup__header">
    <h2>Backups</h2>
    <div>
      <el-button type="primary" icon="el-icon-plus">Backup</el-button>
    </div>
  </div>
  <ul class="backup__list">
    <li class="backup__list--item" v-bind:key="backup.index" v-for="backup in backups">
      <backup-item :backup="backup"></backup-item>
    </li>
  </ul>
  </div>
  <div class="backup-automatic">
    <div class="backup-automatic__header">
      <h2>Automatic backup</h2>
    </div>
    <div class="backup-automatic__form">
      <div class="backup-automatic__form--col-1">
        <p>Perform automatic backup (at 3AM):</p>
        <el-radio v-model="backupFrequency" label="day">Daily</el-radio>
        <el-radio v-model="backupFrequency" label="week">Weekly (recommended)</el-radio>
        <el-radio v-model="backupFrequency" label="month">Monthly</el-radio>
        <el-radio v-model="backupFrequency" label="none">Don't check</el-radio>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import BackupItem from './BackupItem';

export default {
  data: () => ({
    backupFrequency: 'week',
    backups: [
      {
        index: 0,
        name: 'Manual Backup (Web, DB)',
        note: 'Lorem ipsum',
        date: '12.08.2017 14:44',
        weight: 456,
      },
      {
        index: 1,
        name: 'Automatic Backup (Web, Mail, DB)',
        note: 'Lorem ipsum',
        date: '11.07.2017 12:44',
        weight: 451,
      },
    ],
  }),
  components: {
    'backup-item': BackupItem,
  },
};
</script>
<style lang="scss">
.advanced {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 50px;
  width: calc(100% - 100px);

  .backup {
    &__header {
      width: 100%;
      margin: 10px 0 30px 0;
      border-bottom: 1px solid #aaaaaa;
      display: flex;
      justify-content: space-between;
      align-items: center;

        h2 {
          text-align: left;
          font-size: 24px;

          span {
            font-size: 16px;
            font-weight: 300;
          }
        }
    }

    &__list {
      list-style: none;
      padding: 0;

      &--item {
        position: relative;
      }
    }
  }

  .backup-automatic {
    &__header {
      width: 100%;
      margin: 20px 0 10px 0;
      border-bottom: 1px solid #aaaaaa;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }
      }
    }

    &__form {
      display: flex;
      justify-content: stretch;
      align-items: flex-start;

      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }

      p {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 5px;
      }

      label {
        font-size: 14px;
      }

      .el-radio {
        margin: 5px 0;
      }

      .el-checkbox {
        margin-top: 16px;

        &__label {
          font-size: 16px;
          font-weight: 500;
        }
      }

      .el-input {
        margin-top: 15px;
        margin-left: 20px;
        max-width: 350px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Advanced.vue